import React from "react";
import { Link } from "react-router-dom";

import "./styles.scss";

export default class BreadcrumbsItem extends React.Component {
  render() {
    var itemText = this.props.text;
    return (
      <div className="breadcrumbsItem">
        <Link>{itemText}</Link>/
      </div>
    );
  }
}
